<template>
    <div>
        <sidebar v-if="$route.name !== 'Login'"></sidebar>

        <b-container class="custom-container">
            <router-view/>
        </b-container>
    </div>

</template>

<script>
import sidebar from "./components/Sidebar"

export default {
    components: {
        'sidebar': sidebar

    },
    mounted() {
        this.checkLogin();
    },
    methods: {
        checkLogin: function () {
            let key = localStorage.getItem("user")
            console.log(key)
            if (!key) {
                this.$router.replace({ name: 'Login' })
            } else {
                this.$router.replace({ name: 'Home' })
            }
        }
    },
    data() {
        return {
            SUPERADMIN: 'superadmin',
            STAFF: 'staff',
            ADMIN: 'admin'
        }
    },

}

</script>

<style>
/*#app {*/
/*  font-family: Avenir, Helvetica, Arial, sans-serif;*/
/*  -webkit-font-smoothing: antialiased;*/
/*  -moz-osx-font-smoothing: grayscale;*/
/*  text-align: center;*/
/*  color: #2c3e50;*/
/*}*/

/*#nav {*/
/*  padding: 30px;*/
/*}*/

/*#nav a {*/
/*  font-weight: bold;*/
/*  color: #c9c5d0;*/
/*}*/

/*#nav a.router-link-exact-active {*/
/*  color: #42b983;*/
/*}*/

/*.nav-item a {*/
/*  color: #ebebeb;*/
/*!*}*!*/

/*!*.nav-item a:hover {*!*/
/*  color: #c2c2c2;*/
/*!*}*!*/

/*  .sidebar {*/
/*    background-color: #3f5063;*/
/*    height: 100%;*/
/*    position: absolute;*/
/*    */
/*  }*/

.custom-container {
    /*width: calc(100% - 180px) !important;*/
    margin-top: 30px;
    margin-left: 220px !important;

}
</style>
